import router from "@/router";
import { apolloClient } from "@/plugins/apollo";
import { SIGNIN_ACCOUNT, SIGNOUT_ACCOUNT } from "@/graphql";

export default {
  signin: ({ commit, dispatch }, payload) => {
    commit("setLoading", true, { root: true });
    dispatch("clearErrors", null, { root: true });
    return apolloClient
      .mutate({
        mutation: SIGNIN_ACCOUNT,
        variables: payload
      })
      .then(({ data }) => {
        dispatch("success", data.signinAccount);
        router.push({ name: "Account" });
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        dispatch("setErrors", error, { root: true });
      });
  },
  signout: ({ commit }) => {
    return apolloClient
      .mutate({ mutation: SIGNOUT_ACCOUNT })
      .then(() => {
        apolloClient.resetStore().then(() => {
          commit("account/setCurrent", null, { root: true });
          router.push({ name: "Authentication" });
        });
      })
      .catch(error => {
        console.error(error);
      });
  },
  success: ({ commit }, payload) => {
    commit("setLoading", false, { root: true });
    commit("account/setCurrent", payload, { root: true });
  },
  toStep: ({ commit }, payload) => {
    commit("setStep", payload);
  }
};
